import { __assign } from 'tslib';
import React__default, { useCallback } from 'react';
import { fetcherModeAtom, elementFetcherSelector, MediaLinksField, getExtension } from '@keepeek/commons';
import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { elementSelector } from '../../providers/elements/selectors.js';
import { thumbnailGeneratorPoiState } from '../../providers/poi/atoms.js';
import { useUserDynameekRights } from '../hooks.js';
import PoiViewer from '../PoiViewer/index.js';

var PoiSidebar = function PoiSidebar(_a) {
    var elementId = _a.elementId, onLayoutWidthChange = _a.onLayoutWidthChange, getFocusPickerFunctions = _a.getFocusPickerFunctions, sx = _a.sx, KIcon = _a.KIcon;
    var t = useTranslation("refront-components").t;
    var _b = useRecoilState(elementSelector(elementId)), element = _b[0], setElement = _b[1];
    var _c = useRecoilState(thumbnailGeneratorPoiState({ elementId: elementId })), poi = _c[0], setPoi = _c[1];
    var fetcherMode = useRecoilValue(fetcherModeAtom);
    var updateElement = useRecoilValue(elementFetcherSelector({ fetcherMode: fetcherMode })).updateElement;
    var _d = useUserDynameekRights(element), isPoiUpdateAllowed = _d.isPoiUpdateAllowed, isPoiUpdateOnElementAllowed = _d.isPoiUpdateOnElementAllowed;
    var handleChange = useCallback(function (x, y) {
        if (!x || !y || (x === poi.x && y === poi.y)) {
            // no change or x or y undefined or user is not allowed => do nothing
            return;
        }
        if (isPoiUpdateOnElementAllowed) {
            var response = updateElement({
                id: elementId,
                pointOfInterest: {
                    x: x,
                    y: y
                }
            });
            response.then(function () {
                setPoi({ x: x, y: y });
                setElement(__assign(__assign({}, element), { pointOfInterest: { x: x, y: y } }));
            });
        }
        else {
            setPoi({ x: x, y: y });
        }
    }, [
        element,
        elementId,
        poi.x,
        poi.y,
        setElement,
        setPoi,
        updateElement,
        isPoiUpdateOnElementAllowed,
    ]);
    return (React__default.createElement(Box, { sx: { overflow: "auto" } },
        React__default.createElement(Box, { "data-testid": "PoiSidebarTestId", sx: { p: 1.5 } },
            React__default.createElement(PoiViewer, { sx: sx, onChange: handleChange, image: element && element._links ? element._links[MediaLinksField.PREVIEW].href : undefined, initialX: poi.x, initialY: poi.y, onLayoutWidthChange: onLayoutWidthChange, getFocusPickerFunctions: getFocusPickerFunctions, KIcon: KIcon, element: element }),
            (!isPoiUpdateOnElementAllowed || !isPoiUpdateAllowed) && (React__default.createElement(Box, { "data-testid": "messageNoRightToUpdatePoiTestId", sx: {
                    fontSize: "13px",
                    color: function (theme) { return theme.palette.info.main; },
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 0.5
                } },
                React__default.createElement(KIcon, { sx: { fontSize: "19px!important" }, className: "fa-solid fa-circle-question" }),
                !isPoiUpdateOnElementAllowed &&
                    isPoiUpdateAllowed &&
                    t("components.kf-thumbnail-generator.poi-sidebar.update-poi.noright-on-element"),
                !isPoiUpdateAllowed &&
                    t("components.kf-thumbnail-generator.poi-sidebar.update-poi.noright")))),
        React__default.createElement(Divider, null),
        React__default.createElement(Box, { sx: { p: 1.5 } },
            React__default.createElement(Box, null,
                React__default.createElement(Typography, { variant: "h6", sx: {
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden"
                    }, title: element === null || element === void 0 ? void 0 : element.title }, element === null || element === void 0 ? void 0 : element.title)),
            React__default.createElement(Typography, null, "".concat(getExtension(element === null || element === void 0 ? void 0 : element.originalFileName) || "", " - ").concat(element === null || element === void 0 ? void 0 : element.fileSizeString, " - ").concat(element === null || element === void 0 ? void 0 : element.width, "x").concat(element === null || element === void 0 ? void 0 : element.height, " px - ").concat(element === null || element === void 0 ? void 0 : element.resolution, " dpi ").concat((element === null || element === void 0 ? void 0 : element.colorSpace) !== undefined ? "- ".concat(element === null || element === void 0 ? void 0 : element.colorSpace) : ""))),
        React__default.createElement(Divider, null)));
};

export { PoiSidebar as default };
//# sourceMappingURL=index.js.map
